<template>
  <div class="card_style">
    <clientSection
      :clientData="offlineData"
      :base_book_id="base_book_id"
      :rooms="offlineData?.rooms"
      @roomAdded="fetchOfflineHotels"
      :is_portal="isPortal"
    />
    <!-- :supplierOptionsDate="supplier"  -->
    <div class="card width_nav">
      <TabView>
        <TabPanel :header="$t('services')">
          <offlineServices
            v-if="$route.params.id"
            :bookStatus="offlineData.book_offline_status"
            :id="offlineData.id"
            :offlineServices="offlineData.service"
            @serviceAdded="fetchOfflineHotels"
          />
          <div class="text-center" v-else>
            <p class="text-danger">{{ $t("must add client data") }}</p>
          </div>
        </TabPanel>
        <TabPanel :header="$t('notes')">
          <NotesSec
            v-if="$route.params.id"
            0
            :id="offlineData.id"
            :note="offlineData.notes?.notes"
          />
          <div class="text-center" v-else>
            <p class="text-danger">{{ $t("must add client data") }}</p>
          </div>
        </TabPanel>
      </TabView>
    </div>
  </div>
</template>

<script>
import clientSection from "@/components/hotelOfflineService/clientSection.vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import NotesSec from "../../../components/offline_booking/NotesSec.vue";
import offlineServices from "@/components/offline_booking/offline_services.vue";
// import paymentMethods from "@/components/offline_booking/paymentMethods.vue";
import axios from "axios";
export default {
  data() {
    return {
      offlineData: {},
      bookId: this.$route.params.id,
      base_book_id: "",
      post_to_account_data: {},
      isPortal: "",
    };
  },

  components: {
    clientSection,
    // paymentMethods,
    TabView,
    TabPanel,
    offlineServices,
    NotesSec,
  },
  methods: {
    fetchOfflineHotels() {
      axios
        .post(`/fetch_specific_offline_booking_hotel`, {
          offline_booking_hotel_id: this.$route.params.id,
        })
        .then((res) => {
          this.offlineData = res.data.data;
          this.base_book_id = res.data.data.base_booking_id;
          this.isPortal = res.data.data.is_portal;
          // console.log(this.isPortal, "www");
          // console.log(
          //   this.offlineData.rooming_list,
          //   "offlineDatarrrrrrrrrrrrrrr"
          // );
        });
    },
    handleRoomingList() {
      this.$refs.roomListRef.fetchRoomingList();
    },
    clearOfflineData() {
      this.offlineData = {};
      this.base_book_id = "";
      this.isPortal = "";
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fetchOfflineHotels();
      // this.is_portal = this.portal_id;
    } else if (this.$route.params.id == undefined) {
      this.clearOfflineData();
    }
  },
  watch: {
    "$route.params.id": {
      handler() {
        if (this.$route.params.id != undefined) {
          this.fetchOfflineHotels();
        } else if (this.$route.params.id == undefined) {
          this.clearOfflineData();
        }
      },
      immediate: true, // Optional: Trigger the effect initially
    },
  },
};
</script>

<style scoped lang="scss">
@import "../hotelsBookOffline/_hotelsBookOffline.scss";
</style>
